function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { SearchItem } from '@ellucian/react-design-system/core/Search';
import PropTypes from 'prop-types';

var DropdownTypeaheadItem = React.forwardRef(function (props, ref) {
    var value = props.value,
        label = props.label,
        rest = _objectWithoutProperties(props, ['value', 'label']);

    return React.createElement(
        SearchItem,
        Object.assign({
            ref: ref,
            'data-value': value,
            divider: true
        }, rest),
        label
    );
});

DropdownTypeaheadItem.muiName = 'DropdownTypeaheadItem';

DropdownTypeaheadItem.propTypes = {

    /**
     * Text of the dropdown item
     */
    label: PropTypes.string.isRequired,

    /**
     * The value.
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,

    /**
     * If `true`, the dropdown item will be disabled, and unselectable.
     */
    disabled: PropTypes.bool,

    /**
     * Icon to be displayed to the the left of the text
     */
    LeftIconComponent: PropTypes.node,

    /**
     * Icon to be displayed to the the right of the text
     */
    RightIconComponent: PropTypes.node

};

DropdownTypeaheadItem.defaultProps = {
    disabled: false,
    LeftIconComponent: null,
    RightIconComponent: null
};

export default DropdownTypeaheadItem;